import React from 'react';

import useApiService from '../../services/useApiService';

const defaultRoles = [
  "Leadership Team",
  "Discovery Manager",
  "Administrative Team",
  "GIS / IT Specialist",
  "Permitting Spec.",
  "Mining Prop. Spec.",
  "Project Manager",
  "Project Geologist",
  "Data Geologist",
  "Mine/Pit Geologist",
  "Logistics Spec.",
  "Operations Spec.",
  "Drilling Specialist",
  "Geochemist",
  "Geometallurgist",
  "Geophysicist",
  "Geosciences Team",
  "Core Farm Technic.",
  "Field Supervisor",
  "Field Technician",
  "Field Assistant",
  "Field Officer",
  "SHEC Mngr/Principal",
  "SHEC Specialist",
  "S&H Specialist",
  "Community Spec.",
  "Environmental Spec.",
  "Security Specialist",
  "Emergency Driver",
  "Professional Driver",
  "SHEC Technician",
  "Safety Technic.",
  "Safety Officer",
  "Environ. Technic.",
  "Community Technic.",
  "Community Assistant",
  "Paramedic / Nurse"
]

const withDefaultRoleOptions = (Component, onMount = true) => {
  return (props) => {
    const payload = { params: { context: 'roles' } };
    const [{ isLoading: isLoadingRoles, response: assignedRoles }, getAssignedRoles] = useApiService({ url: `/tags`, payload: payload, onMount, defaultResponse: []});
    const assignedRolesList = assignedRoles.map((role)=>{ return role.name });
    const defaultRoleOptions = [...new Set(defaultRoles.concat(assignedRolesList))];
    const componentProps = {...props, isLoadingRoles, defaultRoleOptions, assignedRoles, getAssignedRoles }
    return <Component {...componentProps} />;
  };
};

export default withDefaultRoleOptions;


// WEBPACK FOOTER //
// ./src/views/components/with_default_role_options.js